export default "__VITE_ASSET__DtzR0DMh__"